import { render, staticRenderFns } from "./oodrive-failure.vue?vue&type=template&id=01bfa272&"
import script from "./oodrive-failure.vue?vue&type=script&lang=js&"
export * from "./oodrive-failure.vue?vue&type=script&lang=js&"
import style0 from "./oodrive-failure.vue?vue&type=style&index=0&id=01bfa272&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01bfa272')) {
      api.createRecord('01bfa272', component.options)
    } else {
      api.reload('01bfa272', component.options)
    }
    module.hot.accept("./oodrive-failure.vue?vue&type=template&id=01bfa272&", function () {
      api.rerender('01bfa272', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/oodrive-failure.vue"
export default component.exports